import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { isOpen, getMessage, getParams, getOnclose } from './selectors'
import { close } from './actions'

function useModalContainer(name) {
  const dispatch = useDispatch()

  const open = useSelector((state) => isOpen(state, name))
  const message = useSelector((state) => getMessage(state, name))
  const params = useSelector((state) => getParams(state, name))
  const onclose = useSelector((state) => getOnclose(state, name))
  const handleClose = React.useCallback(() => {
    dispatch(close(name))
  }, [dispatch, name])

  return {
    modalInstanceName: name,
    open,
    message,
    params,
    closeModal: handleClose,
    onclose,
  }
}

const getDisplayName = (label, name, Component) =>
  `${label}(${name}, ${Component.displayName || Component.name || 'Component'})`

const DEFAULT_MODAL_INSTANCE_NAME = 'LKModalContainer'

const LKModalContainer = (contextName) => (Component) => {
  const WrapperComponent = (props) => {
    const name = props.name || contextName || DEFAULT_MODAL_INSTANCE_NAME

    const modalContainerProps = useModalContainer(name)

    if (!modalContainerProps.open) {
      return null
    }

    return <Component {...props} name={name} {...modalContainerProps} />
  }

  WrapperComponent.displayName = getDisplayName('withLKModal', contextName || DEFAULT_MODAL_INSTANCE_NAME, Component)

  return WrapperComponent
}

export default LKModalContainer
